import RestService from 'restService';
import RequestThrottle from '../../../../core/RequestThrottle';
import QualityMentoringForm from '../QualityMentoringForm';
import QuestionNoteCollection from '../../components/QuestionNote/QuestionNoteCollection';
import Account from '../../../../core/Account';

export default class Submission {
  data: any = {};

  id: string;

  name: string;

  percentComplete: string;

  organizationName: string = '';

  role: string = '';

  purpose: string = '';

  otherPurpose: string = '';

  throttle: RequestThrottle = new RequestThrottle();

  sharedWith: [] = [];

  async load(id: string): Promise<void> {
    const response = await RestService.get(`submission/${id}`);
    this.id = response.data.id;
    this.name = response.data.name;
    this.percentComplete = response.data.percentComplete;
    this.organizationName = response.data.organizationName;
    this.role = response.data.role;
    this.purpose = response.data.purpose;
    this.otherPurpose = response.data.otherPurpose;
    if (!Array.isArray(response.data.data)) {
      this.data = response.data.data;
    }
    QuestionNoteCollection.questionNotesForSubmission = response.data.questionNotes;
    this.sharedWith = response.data.users.map((user) => new Account(user));
    this.sharedWith.forEach(async (account: Account) => await account.load());
    return Promise.resolve();
  }

  async updateNotes() {
    const response = await RestService.get(`submission/${this.id}`);
    QuestionNoteCollection.questionNotesForSubmission = response.data.questionNotes;
  }

  async save(): Promise<any> {
    if (!this.id) {
      const response = await RestService.post('submission', {
        submission: this,
      });
      this.id = response.data.id;
    } else {
      this.throttle.begin(async () => {
        RestService.put(`submission/${this.id}`, {
          submission: this,
          percentComplete: QualityMentoringForm.getInstance().percentComplete,
        })
          .finally(() => {
            this.throttle.end();
          });
      });
    }
    return Promise.resolve();
  }

  async share(email: string): Promise<any> {
    const response = await RestService.post(`submission/${this.id}/share`, {
      email,
    });
    return response;
  }
}
